import { render, staticRenderFns } from "./SearchNotFoundResults.vue?vue&type=template&id=f42d2a86&"
import script from "./SearchNotFoundResults.vue?vue&type=script&lang=ts&"
export * from "./SearchNotFoundResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchNotFoundResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports